import { useEffect } from "react";

// Extend the window type for TypeScript
declare global {
  interface Window {
    interdeal?: any;
  }
}

export function useEqualWebAccessibility() {
  useEffect(() => {
    // Only add once
    if (window.interdeal || document.getElementById("equalweb-script")) return;

      window.interdeal = {
      get sitekey (){ return "5bd402211671cb0f762d9bd1a8a7ae96"} ,
      get domains(){
          return {
              "js": "https://cdn.equalweb.com/",
              "acc": "https://access.equalweb.com/"
          }
      },
      "Position": "right",
      "Menulang": "HE",
      "draggable": true,
      "btnStyle": {
          "vPosition": [
              "80%",
              "80%"
          ],
          "margin": [
              "0",
              "0"
          ],
          "scale": [
              "0.5",
              "0.5"
          ],
          "color": {
              "main": "#21469c",
              "second": "#ffffff"
          },
          "icon": {
              "outline": false,
              "outlineColor": "#ffffff",
              "type":  11 ,
              "shape": "semicircle"
          }
      },
                                
  };

  (function(doc, head, body){
      var coreCall             = doc.createElement('script');
      coreCall.src             = window.interdeal.domains.js + 'core/5.1.13/accessibility.js';
      coreCall.defer           = true;
      coreCall.integrity       = 'sha512-70/AbMe6C9H3r5hjsQleJEY4y5l9ykt4WYSgyZj/WjpY/ord/26LWfva163b9W+GwWkfwbP0iLT+h6KRl+LoXA==';
      coreCall.crossOrigin     = 'anonymous';
      coreCall.setAttribute('data-cfasync', "true" );
      body? body.appendChild(coreCall) : head.appendChild(coreCall);
  })(document, document.head, document.body);

    // (Optional) cleanup: you can remove the script on unmount if needed
    // return () => { script.remove(); };
  }, []);
}
